import { withLeaflet, GridLayer } from 'react-leaflet';
import { TileLayer as LeafletTileLayer } from 'leaflet';
import { isTSExpressionWithTypeArguments } from '@babel/types';

// import { withLeaflet } from './context'
// import GridLayer from './GridLayer'
// import type { GridLayerProps } from './types'

// type LeafletElement = LeafletTileLayer
// type Props = { url: string } & GridLayerProps

class TileLayer extends GridLayer<any, any> {
  _tileSizes: any;

  createLeafletElement(props: any): any {
    // return new LeafletTileLayer(props.url, this.getOptions(props))
    // if (props.tileSizes) {

    const { tileSizes, tileImg } = props;

    const MapTileLayer = LeafletTileLayer.extend({
      createTile: function(coords: any, done: Function) {
        const { z, x, y } = coords;
        // // do not provide an image beyond the supported range
        if (!tileSizes[z]) {
          return document.createElement('div');
        }
        const [maxX, maxY] = tileSizes[z];
        // do not provide an image if there are no tiles in that area
        if (x < 0 || y < 0 || maxX < x || maxY < y) {
          return document.createElement('div');
        }
        const fileURI =
          'https://koholint-island.s3.ap-northeast-2.amazonaws.com';

        let tileSrc = `${fileURI}/${tileImg}`
          .replace(/{z}/, z)
          .replace(/{x}/, x)
          .replace(/{y}/, y);

        // // console.log({ maxX, maxY });

        if (x === 0 || y === 0 || x === maxX || y === maxY) {
          // console.log({ x, y });
          tileSrc = tileSrc.replace(/\.jpeg$/, '.png');
        }
        var tile = document.createElement('img');
        tile.onload = () => {
          tile.style.width = 'auto';
          tile.style.height = 'auto';
          // tile.style.width = '256px';
          // tile.style.height = '256px';
          // tile.style.opacity = '0.1';
          done(null, tile);
        };
        //   tile.style.width = '256px';
        //   tile.style.height = '256px';
        //   tile.style.border = '5px solid blue';
        //   tile.style.background = 'lightyellow';
        //   tile.innerHTML = `${z}_${x}_${y}`

        //   tile.style.visibility = 'visible'
        // done(null, tile);
        tile.src = tileSrc;
        // tile.src =
        //   'https://cdn.shopify.com/s/files/1/0051/4802/products/stickers_octocat_600x600.png?v=1520903827';
        // done(null, tile);
        // done(null, tile);
        return tile;
      },
    });

    return new MapTileLayer();
    // {
    //   // minZoom,
    //   // maxZoom,
    //   tms: false,
    //   continuousWorld: 'false',
    //   noWrap: false,
    //   defaultRadius: 1,
    // });
  }

  // updateLeafletElement(fromProps: any, toProps: any) {
  //   super.updateLeafletElement(fromProps, toProps)
  //   // if (toProps.url !== fromProps.url) {
  //   //   // @ts-ignore
  //   //   this.leafletElement.setUrl(toProps.url)
  //   // }
  // }
}

export default withLeaflet(TileLayer);
